import ScreenWrapper from "@/components/ScreenWrapper"
import IntakeDetail from "@/pages/intakes/$intakeId"
import { IntakeSidebar } from "@/pages/intakes/$intakeId/components/IntakeSidebar"
import { checkPermissions } from "@/utils/checkPermissions"
import { createFileRoute, useParams } from "@tanstack/react-router"
import { LayoutWithSidebar, Skeleton } from "toptaal-shared"

export const Route = createFileRoute("/beheer/intakes/$intakeId/")({
  component: RouteComponent,
  beforeLoad: () => checkPermissions("read", "intake"),
})

function RouteComponent() {
  const { intakeId } = useParams({ from: "/beheer/intakes/$intakeId/" })

  return (
    <ScreenWrapper className="!px-0">
      <LayoutWithSidebar
        skeleton={<Skeleton className="h-[310px]" />}
        sidebar={<IntakeSidebar intakeId={Number(intakeId)} />}
      >
        <IntakeDetail intakeId={Number(intakeId)} />
      </LayoutWithSidebar>
    </ScreenWrapper>
  )
}
